// extracted by mini-css-extract-plugin
export default {"container":"Products_container__czCMi","products":"Products_products__vpNrf","menu":"Products_menu__VGmNk","list":"Products_list__U9I2F","product":"Products_product__RAwQO"};